module.exports = __webpack_public_path__ + "img/c03_unitlongswordsmanchampion_Normal_ua.2ef382ba.webp";